import axios from 'axios'
import { UrlBase, OAuthUrlBase } from './config'

const auth = {}

auth.getDataFromTheInvitation = async (invitation) => {
  try {
    const response = await axios.get(UrlBase + 'invitation/data/' + invitation)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

auth.getRegisteredEmails = async () => {
  try {
    const request = {
      method: 'GET',
      url: OAuthUrlBase + 'gmail/linked/account'
    }

    const response = await axios(request)

    if (response.data) {
      return response.data.accounts
    }

    return []
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

auth.updateLimitsForEmail = async data => {
  try {
    const { email, limitPer24Hours, limitPerHour } = data
    const request = {
      data: {
        email,
        limitPer24Hours,
        limitPerHour
      },
      method: 'PUT',
      url: OAuthUrlBase + 'gmail/linked/account'
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

auth.loginEmail = async ({ userData, password }) => {
  try {
    const response = await axios.post(UrlBase + 'login/email', { email: userData, password })
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

auth.loginPhone = async ({ userData, password }) => {
  try {
    const response = await axios.post(UrlBase + 'login/phone', { phone: userData, password })
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

auth.register = async ({ country, email, phone, password, name }) => {
  try {
    const response = await axios.post(UrlBase + 'register', { country, email, phone, password, name })
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

auth.registerEmail = async ({ email, password, name }) => {
  try {
    const response = await axios.post(UrlBase + 'register/email', { email, password, name })
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

auth.registerEmailInvitation = async ({ email, password, name, phone, invitationCode }) => {
  try {
    const response = await axios.post(UrlBase + 'register/email/invitation', { email, password, name, phone, invitationCode })
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

auth.resetPasswordEmail = async email => {
  try {
    const response = await axios.post(UrlBase + 'login/email/reset', { email })
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

auth.resetPasswordPhone = async (phone, country) => {
  try {
    const response = await axios.post(UrlBase + 'login/phone/reset', { phone, country })
    console.log(response)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

auth.resetPasswordValidation = async ({ code, password }) => {
  try {
    const response = await axios.post(UrlBase + 'login/reset/validation', { code, password })
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

export default auth
